/**
 * 系统管理公共接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogLoginService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 登录日志接口
  /**
   * 查询登入日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getLogLoginList(param) {
    const url = this.prefix + 'loginLog/queryPageList';
    return this.http.Post(url, param);
  }
 /**
   * 查询登录日志所有信息
   * @param param
   * @returns {Observable<any>}
   */
  exportLoginLogList(param) {
    const url = this.prefix + 'loginLog/export';
    let headers = this.http.SetHeader();
    return this.httpClient.post(url, param, { responseType: 'blob', observe: 'response', headers: headers });
  }
  //#endregion

}
